import { FORMER_CUSTOMER_ADDRESS_DOB_SUCCESS } from "../actions/types";

const initialState = {
  email:"",
  intent:""
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FORMER_CUSTOMER_ADDRESS_DOB_SUCCESS:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
